export const paths = {
  main: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  register: '/register',
  registerOrganization: '/register/organization',
  verifyEmail: '/verify-email',
  shipments: '/shipments',
  shipmentDetails: '/shipments/:id',
  shipmentDeliveryDetails: '/shipments/:id/shipment-details',
  shipmentSupplierData: '/shipments/:id/supplier-data',
  aiServiceItemEdit: '/ai-service/:agentSessionId/items/:itemId',
  aiServiceItems: '/ai-service/:agentSessionId/items',
  shipmentAttachments: '/shipments/:id/attachments',
  shipmentSupplierDropOff: '/shipments/:id/supplier-drop-off',
  shipmentTimeline: '/shipments/:id/timeline',
  shipmentHistory: '/shipments/:id/history',
  shipmentItems: '/shipments/:id/items',
  shipmentItemSku: '/shipments/:id/items/:itemId',
  shipmentReception: '/shipments/:id/reception',
  shipmentReceptionResolution: '/shipments/:id/reception/resolution',
  shipmentReceptionSku: '/shipments/:id/reception/sku/:itemId',
  shipmentReceptionMedia: '/shipments/:id/reception/media',
  shipmentBudget: '/shipments/:id/budget',
  shipmentBudgetServices: '/shipments/:id/budget/services',
  shipmentCustomsClearance: '/shipments/:id/customs-clearance',
  finance: '/finance',
  financeOperationHistory: '/finance/operation-history',
  financeUpcomingPayments: '/finance/upcoming-payments',
  financeNested: '/finance/*',
  profile: '/profile',
  profileEdit: '/profile/edit',
  profileOrganizationEdit: '/profile/organization/edit',
  profileWarehouse: '/profile/warehouses/:warehouseId',
  profileWarehouseCreate: '/profile/warehouses/new',
  profileWarehouses: '/profile/warehouses',
  profileNested: '/profile/*',
  deliveryWarehouseDistribution: '/warehouses/delivery',
  deliveryWarehouseProducts: '/warehouses/delivery/products',
  deliveryWarehouseCreate: '/warehouses/delivery/new',
  notFound: '*'
} as const;